import { explorerUrl } from '@/js/helpers/urls'
import moment from 'moment'
import BigNumber from 'bignumber.js'

const colors = [
  '#ff9e9a',
  '#000000',
  '#A52A2A',
  '#8A2BE2',
  '#0000FF',
  '#DEB887',
  '#5F9EA0',
  '#7FFF00',
  '#D2691E',
  '#FF7F50',
  '#6495ED',
  '#DC143C',
  '#00FFFF',
  '#00008B',
  '#008B8B',
  '#B8860B',
  '#006400',
  '#BDB76B',
  '#8B008B',
  '#556B2F',
  '#FF8C00',
  '#9932CC',
  '#8B0000',
  '#E9967A',
  '#8FBC8F',
  '#483D8B',
  '#2F4F4F',
  '#00CED1',
  '#9400D3',
  '#FF1493',
  '#00BFFF',
  '#1E90FF',
  '#228B22',
  '#B22222',
  '#FF00FF',
  '#DAA520',
  '#FFD700',
  '#008000',
  '#ADBA3F',
  '#FF69B4',
]

const tvlTypes = [
  {
    id: 'token_tvl',
    label: 'All tokens',
  },
  {
    id: 'dotc_tvl',
    label: 'dOTC',
  },
]

export const tvlTypesAsObject = {}
tvlTypes.forEach((row) => {
  tvlTypesAsObject[row.id] = row.id
})

export default {
  props: {
    network: {
      type: Object,
      required: true,
      default: () => {},
    },
    tvlType: {
      type: String,
      required: true,
      default: tvlTypesAsObject.token_tvl,
    },
    title: {
      type: String,
      required: true,
      default: 'Tokens',
    },
  },
  data () {
    return {
      loading: false,
      tvl: [],
      colors,
      symbols: [],
      symbolColors: {},
      filters: {
        chainId: this.network.chainId,
        type: null,
        createdAtFrom: moment(new Date()).subtract(7, 'days').toDate().toISOString(),
        createdAtTo: moment(new Date()).toDate().toISOString(),
        symbol: [],
        groupBy: null,
      },
    }
  },
  computed: {
    tokens () {
      const result = this.getSymbols(this.tvl)
      return result
    },
  },
  watch: {
    filters: {
      handler () {
        this.getTvls()
        this.fillGChartSeries(this.filters.symbol)
      },
      deep: true,
    },
  },

  methods: {
    getTokenExplorerUrl (item) {
      return explorerUrl('address', item.ethAddress, this.network.explorerUrl)
    },

    setSelectedSymbols (val) {
      if (val.includes('unselect')) {
        this.filters.symbol = []
        return
      }
      if (val.includes('selectAll')) {
        this.filters.symbol = this.symbols
        return
      }
      this.filters.symbol = val
    },
    getMaxUsdValue () {
      let maxValue = new BigNumber(0)

      this.tvl.forEach(record => {
        const comparedValue = new BigNumber(record.usdValue)
        if (maxValue.comparedTo(comparedValue) < 0) {
          maxValue = comparedValue
        }
      })
      return maxValue
    },

    tagStyle (sym) {
      return { borderBottom: `1em solid ${this.symbolColors[sym]}` }
    },
  },
}
